/* eslint-disable max-statements */

export const LOAD_MODEL_REQUESTED = "WORKFLOW_EDITOR_SCHEMA/LOAD_MODEL_REQUESTED";
export const LOAD_MODEL_SUCCESS = "WORKFLOW_EDITOR_SCHEMA/LOAD_MODEL_SUCCESS";
export const LOAD_MODEL_FAIL = "WORKFLOW_EDITOR_SCHEMA/LOAD_MODEL_FAIL";

export const SAVE_MODEL_REQUESTED = "WORKFLOW_EDITOR_SCHEMA/SAVE_MODEL_REQUESTED";
export const SAVE_MODEL_SUCCESS = "WORKFLOW_EDITOR_SCHEMA/SAVE_MODEL_SUCCESS";
export const SAVE_MODEL_FAIL = "WORKFLOW_EDITOR_SCHEMA/SAVE_MODEL_FAIL";

export const ACTIVATE_MODEL_REQUESTED = "WORKFLOW_EDITOR_SCHEMA/ACTIVATE_MODEL_REQUESTED";
export const ACTIVATE_MODEL_SUCCESS = "WORKFLOW_EDITOR_SCHEMA/ACTIVATE_MODEL_SUCCESS";
export const ACTIVATE_MODEL_FAIL = "WORKFLOW_EDITOR_SCHEMA/ACTIVATE_MODEL_FAIL";

export default (state = {
    errors: [],
    hasInitialData: false,
    loading: 0,
    model: {},
    updating: 0
}, { type, data }) => {
    switch (type) {
    case LOAD_MODEL_REQUESTED: {
        ++state.loading;
        return state;
    }
    case LOAD_MODEL_SUCCESS: {
        --state.loading;
        state.hasInitialData = true;
        state.model = data;
        return state;
    }
    case LOAD_MODEL_FAIL: {
        --state.loading;
        state.errors.push({ error: data, type });
        return state;
    }
    case SAVE_MODEL_REQUESTED: {
        ++state.loading;
        return state;
    }
    case SAVE_MODEL_SUCCESS: {
        --state.loading;
        state.model = data;
        return state;
    }
    case SAVE_MODEL_FAIL: {
        --state.loading;
        state.errors.push({ error: data, type });
        return state;
    }
    case ACTIVATE_MODEL_REQUESTED: {
        ++state.loading;
        return state;
    }
    case ACTIVATE_MODEL_SUCCESS: {
        --state.loading;
        state.model = data;
        return state;
    }
    case ACTIVATE_MODEL_FAIL: {
        --state.loading;
        state.errors.push({ error: data, type });
        return state;
    }
    default: return state;
    }
};

export const requestLoadWorkflowModel = data => ({ type: LOAD_MODEL_REQUESTED, data });
export const successLoadWorkflowModel = data => ({ type: LOAD_MODEL_SUCCESS, data });
export const failLoadWorkflowModel = data => ({ type: LOAD_MODEL_FAIL, data });

export const requestSaveWorkflowModel = (data, resolve, reject) => ({ type: SAVE_MODEL_REQUESTED, data, resolve, reject });
export const successSaveWorkflowModel  = data => ({ type: SAVE_MODEL_SUCCESS, data });
export const failSaveWorkflowModel  = data => ({ type: SAVE_MODEL_FAIL, data });

export const requestActivateWorkflow = (data, resolve, reject) => ({ type: ACTIVATE_MODEL_REQUESTED, data, resolve, reject });
export const successActivateWorkflow  = data => ({ type: ACTIVATE_MODEL_SUCCESS, data });
export const failActivateWorkflow  = data => ({ type: ACTIVATE_MODEL_FAIL, data });

